import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Modal for archiving a booking with a cancellation note
 */
const ArchiveBookingModal = ({ open, booking, onClose, onConfirm }) => {
  const [cancellationNote, setCancellationNote] = useState("");

  const handleConfirm = () => {
    onConfirm(cancellationNote);
    setCancellationNote(""); // Reset the note for next time
  };

  const handleClose = () => {
    onClose();
    setCancellationNote(""); // Reset the note when modal is closed
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "8px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          color: "#444349",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Archiver la réservation
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ color: "#676767" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ mb: 1, color: "#676767" }}>
            Cette action va archiver la réservation et notifier le client.
            Veuillez fournir une note expliquant la raison de l'annulation:
          </Typography>

          {booking && (
            <Box
              sx={{
                bgcolor: "rgba(200, 70, 83, 0.05)",
                p: 2,
                borderRadius: "8px",
                mb: 2,
                border: "1px solid rgba(200, 70, 83, 0.2)",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", color: "#444349" }}
              >
                Détails de la réservation:
              </Typography>
              <Typography variant="body2" sx={{ color: "#676767" }}>
                Client:{" "}
                {booking.name ||
                  `${booking.firstName || ""} ${booking.lastName || ""}`}
              </Typography>
              <Typography variant="body2" sx={{ color: "#676767" }}>
                Email: {booking.email}
              </Typography>
              <Typography variant="body2" sx={{ color: "#676767" }}>
                Téléphone: {booking.phone}
              </Typography>
            </Box>
          )}

          <TextField
            autoFocus
            label="Note d'annulation"
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={cancellationNote}
            onChange={(e) => setCancellationNote(e.target.value)}
            placeholder="Veuillez expliquer la raison de l'annulation..."
            required
            InputProps={{
              sx: {
                borderRadius: "8px",
              },
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: "16px 24px" }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          sx={{
            color: "#676767",
            borderColor: "#676767",
            "&:hover": {
              borderColor: "#444349",
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
            borderRadius: "8px",
            textTransform: "none",
          }}
        >
          Annuler
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!cancellationNote.trim()}
          sx={{
            backgroundColor: "#c84653",
            "&:hover": {
              backgroundColor: "#a93a46",
            },
            borderRadius: "8px",
            textTransform: "none",
          }}
        >
          Confirmer l'archivage
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveBookingModal;
